// Tech hub selector
//
// Simple listener to redirect the user when a select box change
// -----------------------------------------------------------

$('.js-select-redirect').on('change', 'select', function() {
    if (this.value) {
        window.location.href = this.value;
    }

    return false;
});



// WEBPACK FOOTER //
// ./src/js/components/select-redirect.js